import React, {useRef} from 'react'
import './contact.css'
import {HiOutlineMail} from 'react-icons/hi'
import {BsWhatsapp} from 'react-icons/bs'
import emailjs from 'emailjs-com'
import { formatDiagnostic } from 'typescript'

const Contact = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_nfqckrs', 'template_e95y5r8', form.current, 'T-H__BwHWJhw7T0C8')
      .then((result) => {
        alert('Mail sent, I will get back soon')
          e.target.reset();
      }, (error) => {
        alert('Error in sending the mail. Please try again later')
      });
  };
  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <HiOutlineMail className="contact__option-icon"/>
            <h4>Email</h4>
            <h5>wanderasimoh@gmail.com</h5>
            <a href="mailto:wanderasimoh.com" target = "_blank"> Send a message</a>
          </article> 

          <article className="contact__option">
            <BsWhatsapp className="contact__option-icon"/>
            <h4>WhatsApp</h4>
            <h5>+254713103666</h5>
            <a href="https://wa.me/254713103666" target = "_blank"> Send a message</a>
          </article> 

        </div>
        {/* END OF THE CONTACT OPTIONS */}
        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name="name" placeholder="Your Full Name" required />
          <input type="email" name="email" placeholder="Your Email" required />
          <textarea name="message" cols="7" placeholder = "your message" required></textarea>
          <button type='submit' className="btn btn-primary">Send Message</button>
        </form>

      </div>
    </section>
  )
}

export default Contact
